export const MASTER_API = "https://d7gpkng1a84se.cloudfront.net/api";
export const ORDER_API = "https://d2d06bhzkmhs11.cloudfront.net/api";
export const PURCHASE_API = "https://d10snuif8hpah5.cloudfront.net/api";
